import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import BASEURL, { imgurl } from "../pages/Utils/Baseurl";

import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { gql } from "@apollo/client";

import Swal from "sweetalert2";
import axios from "axios";

import {
  ALL_SALARY_STRUCTURE,
  allempquery,
  OfferletterCreate,
  UpdateAppointment,
  UpdateOfferLetter,
  UpdatePayslip,
} from "./Graphql";
import { useEffect, useState } from "react";
import Payslip from "./Dialogcontents/payslip";
import Offerletter from "./Dialogcontents/offerletter";
import Onboarding from "./Dialogcontents/Onboarding";
import {
  assetrequest,
  generateappointment,
  sendonboardingmail,
} from "./mutation";
import AssetRequest from "./Dialogcontents/assetrequest";
import AppointmentLetter from "./Dialogcontents/appointmnetletter";
import MaterialBox from "../components/MaterialBox";
import MaterialTypography from "../components/MaterialTypography";

const RequestDialog = ({
  open,
  setOpen,
  currentrequest,
  recruitmentdata,
  setrecruitmentdata,
  confirmationDialog,
  setConfirmationDialog,
  handlerecruitmentchange,
  getrecruitmentprocess,
}) => {
  const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });

  const [SalaryStructure, setSalaryStructure] = useState([]);
  const [allowOfferSubmit, setAllowOfferSubmit] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const [Allemail, setAllemail] = useState([]);

  useEffect(() => {
    Allsalarystructure();

    onEmployeeeSubmit();
  }, []);

  const onEmployeeeSubmit = async () => {
    const query = `query{
    allUsersDetail{
    id
    lastLogin
    username
    firstName
    lastName
    isActive
    dateJoined
    email
    salutation
    dateOfBirth
    contactNumber
    emergencyContact
    gender
    employeeType
    lastUpdate
    department
    designation
    empid
    teamleader 
    grade
    }}`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.allUsersDetail;

      let alldata = result.map((data) => {
        return {
          value: data.email,
          label: data.email,
        };
      });

      setAllemail(alldata);
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };

  const Allsalarystructure = async () => {
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: ALL_SALARY_STRUCTURE,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Salary:", response.data.data.salaryStructures);

      let result = response.data.data.salaryStructures;

      setSalaryStructure(result);
    } catch (error) {}
  };

  const handlePay = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are You Sure to Proceed Further ?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handlePayslip();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  //payslip
  const handlePayslip = async () => {
    console.log("inside handlepoaysliop");

    const query = gql`
      mutation CreateRecruitmentProcess($input: RecruitmentProcessInput!) {
        createRecruitmentProcess(input: $input) {
          recruitmentProcess {
            id
            screening
            technicalInterview
            interviewStatus
            offerLetter
            onBording
            assertRequest
            documentVerification
            appointmentLetter
            nda
            hrInduction
            technicalInduction
            teamIntro
            assestHandover
            hrmsAccess
            handoverToManager
          }
          success
          message
        }
      }
    `;

    try {
      const variables = {
        input: {
          staffRequestId: recruitmentdata?.staffrequestid,
          sourcingScreeningId: recruitmentdata?.sourcingscreeningid,
          technicalFeedbackId: recruitmentdata?.technicalfeedbackid,
          payslipFile: recruitmentdata?.payslipfile || "Nil",
          screening: false,
          technicalInterview: false,
          interviewStatus: false,
          offerLetter: false,
          onBording: false,
          assertRequest: false,
          documentVerification: false,
          appointmentLetter: false,
          nda: false,
          hrInduction: false,
          technicalInduction: false,
          teamIntro: false,
          assestHandover: false,
          hrmsAccess: false,
          handoverToManager: false,
        },
      };
      console.log("variablessss:", variables);

      const response = await client.mutate({
        mutation: query,
        variables: variables,
      });

      const finalData = response.data.createRecruitmentProcess;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (finalData?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Payslip Uploaded Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        setOpen(false);
      }
      else{
        Swal.fire({
          position: "center",
          icon: "error",
          title: finalData?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);

      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    } finally {
      getrecruitmentprocess();
    }
  };

  const handleupdatepayslip = async () => {
    const query = `
      mutation UpdateRecruitmentProcess($id: ID!, $input: RecruitmentProcessInput!) {
        updateRecruitmentProcess(id: $id, input: $input) {
          recruitmentProcess {
            id
            screening
            technicalInterview
            interviewStatus
            offerLetter
            onBording
            assertRequest
            documentVerification
            appointmentLetter
            nda
            hrInduction
            technicalInduction
            teamIntro
            assestHandover
            hrmsAccess
            handoverToManager
          }
          success
          message
        }
      }
    `;

    try {
      const variables = {
        id: recruitmentdata?.recruitmentprocessid,
        input: {
          payslipFile: recruitmentdata?.payslipfile,
          screening: recruitmentdata?.screening ?? false,
          technicalInterview: recruitmentdata?.technicalInterview ?? false,
          interviewStatus: recruitmentdata?.interviewStatus ?? false,
          offerLetter: recruitmentdata?.recruitmentdata ?? false,
          onBording: recruitmentdata?.onBording ?? false,
          assertRequest: recruitmentdata?.assertRequest ?? false,
          documentVerification: recruitmentdata?.documentVerification ?? false,
          appointmentLetter: recruitmentdata?.appointmentLetter ?? false,
          nda: recruitmentdata?.nda ?? false,
          hrInduction: recruitmentdata?.hrInduction ?? false,
          technicalInduction: recruitmentdata?.technicalInduction ?? false,
          teamIntro: recruitmentdata?.teamIntro ?? false,
          assestHandover: recruitmentdata?.assestHandover ?? false,
          hrmsAccess: recruitmentdata?.hrmsAccess ?? false,
          handoverToManager: recruitmentdata?.handoverToManager ?? false,
        },
      };

      console.log("variables:", variables);

      if (variables.input.payslipFile !== "Nil") {
        try {
          const response = await client.mutate({
            mutation: gql(query), //  Use gql only with Apollo Client
            variables,
          });

          console.log(
            "GraphQL Response:",
            response.data.updateRecruitmentProcess
          );

          let result = response.data?.updateRecruitmentProcess;

          if (result?.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Payslip Updated Successfully!",
              showConfirmButton: false,
              timer: 2500,
            });

            setOpen(false);
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: result?.message,
              showConfirmButton: false,
              timer: 2500,
            });
            setOpen(false);
          }
        } catch (error) {
          console.error("Apollo Mutation Error:", error);
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Cannot Able To update Payslip !",
            showConfirmButton: false,
            timer: 2500,
          });
          setOpen(false);
        } finally {
          getrecruitmentprocess();
        }
      } else {
        try {
          const response = await axios.post(
            BASEURL,
            {
              query, // ✅ Pass string query
              variables,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          let result = response.data.data?.updateRecruitmentProcess;

          if (result.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Payslip Updated Successfully!",
              showConfirmButton: false,
              timer: 2500,
            });

            setOpen(false);
          }
        } catch (error) {
          console.error("Axios Mutation Error:", error);
        } finally {
          getrecruitmentprocess();
        }
      }
    } catch (error) {
      console.error("Mutation Error:", error);
    } finally {
      getrecruitmentprocess();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleFileUpload = (files) => {
    if (files.length > 0) {
      const file = files[0];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes

      if (file.size > maxSize) {
        alert("File size exceeds 2MB. Please upload a smaller file.");
        return; // Stop execution if file is too large
      }

      //   setrecruitmentdata((prev)=>({
      //     ...prev,
      //     payslipname:file?.name,
      //     payslipfile:file
      //   }));

      if (
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        setrecruitmentdata((prev) => ({
          ...prev,
          payslipname: file?.name,
          payslipfile: file,
        }));
      } else {
        alert(
          "Unsupported file format. Please upload a PDF, DOC, or DOCX file."
        );
      }
    }
  };

  //offer letter

  const handleoffer = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleofferletter();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  // create offer letter
  const handleofferletter = async () => {
    const variables = {
      recruitmentProcessId: recruitmentdata?.recruitmentprocessid
        ? recruitmentdata?.recruitmentprocessid
        : "",
      salaryStructureId: recruitmentdata?.salarystructure?.value,
      ctc: recruitmentdata?.ctc,
      basicPercentage: recruitmentdata?.basicPercentage,
      date: recruitmentdata?.joiningdate,
      branchId: null,
    };

    if (variables.recruitmentProcessId == "") {
      Swal.fire({
        icon: "warning",
        title: "Upload the PaySlip First!",
      });
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      return;
    }

    const variables1 = {
      id: recruitmentdata?.recruitmentprocessid,
      input: {
        offerLetter: true,
      },
    };

    try {
      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: OfferletterCreate,
            variables: variables,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdatePayslip,
            variables: variables1,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      console.log("response1:", response1);
      console.log("response2:", response2.data.data.updateRecruitmentProcess);
      let result1 = response1.data.data.onboardCalculateEmployeeSalary;
      let result2 =
        response2.data.data.updateRecruitmentProcess.recruitmentProcess;
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      console.log(result1, result2, "res1 and 2");

      if (result1 && result2) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Offer Letter Created Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setOpen(false);
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cannot Able TO create Offer Letter Try After SomeTime !",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.log("Error:", error);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Cannot Able TO create Offer Letter Try After SomeTime !",
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      getrecruitmentprocess();
    }
  };

  //update offer letter

  const OfferleterUpdate = async () => {
    const variables = {
      input: {
        id: recruitmentdata?.offerid,
        salaryStructureId: recruitmentdata?.salarystructure?.value,
        basicPercentage: recruitmentdata?.basicPercentage,
        ctc: recruitmentdata?.ctc,
        date: recruitmentdata?.joiningdate,
      },
    };

    console.log("variables:", variables);

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: UpdateOfferLetter, // Correctly placing the mutation inside query
          variables: variables, // Including variables correctly
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data?.updateOnboardEmployeeSalary;

      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Offer Letter Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setOpen(false);
      }
    } catch (error) {
      console.log("UpdateOfferError:", error.message);
      Swal.fire({
        position: "center",
        icon: "error",
        title: error.message,
        showConfirmButton: false,
        timer: 2500,
      });
      setOpen(false);
    } finally {
      getrecruitmentprocess();
    }
  };
  //--------------------------------------------------
  // create or update onboarding

  const handleOnboarding = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to send the mail?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        Onboardingmailrequest();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const Onboardingmailrequest = async () => {
    let Emaildata = recruitmentdata?.onboardccmail?.map((data) => data.label);
    console.log("Input_data:", Emaildata);

    let Input_data = {
      toEmail: recruitmentdata?.onboardtoemail?.value,
      content: recruitmentdata?.onboardcontent,
      ccEmails: Emaildata,
      subject: "Welcome to the Team!",
    };

    const variables = {
      id: recruitmentdata?.recruitmentprocessid, // Ensure filterdata has a valid id before calling API
      input: {
        onBording: true,
      },
    };

    try {
      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: sendonboardingmail,
            variables: { input: Input_data },
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdatePayslip,
            variables: variables,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      console.log("response1:", response1.data.data.SendOnboardingMail);
      console.log("response2:", response2.data.data.updateRecruitmentProcess);

      let result = response1.data.data.SendOnboardingMail;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Mail Sent Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setOpen(false);
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Mail Not Sent!",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Mail Not Sent!",
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      getrecruitmentprocess();
    }
  };

  //   ----------------------------

  const handleassertmail = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleAssest();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleAssest = async () => {
    let Emaildata = recruitmentdata?.assetcc.map((data) => data.label);

    let Input_data = {
      assetName: recruitmentdata.assetName,
      requestId: "REQ1234523",
      reminderTime:
        new Date().toISOString().split("T")[0] +
        "T" +
        recruitmentdata.remaindertime +
        ":00Z", // Convert to DateTime format

      reminderContent: recruitmentdata.assetcontent,
      toEmail: recruitmentdata?.assetcharge?.value,
      ccEmails: Emaildata,
    };

    const variables = {
      id: recruitmentdata?.recruitmentprocessid,
      input: {
        assertRequest: true,
      },
    };

    try {
      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: assetrequest,
            variables: { assetRequest: Input_data },
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdatePayslip,
            variables: variables,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      let result = response1.data.data.SendAssetRequestMail;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Assert Request Sent Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        setOpen(false);
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Assert Request Not Sent",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Assert Request Not Sent",
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      getrecruitmentprocess();
    }
  };

  //---------------------------

  // Appointment

  //submit
  const CreateAppointment = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to submit the details?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleSubmitAppoint();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleSubmitAppoint = async () => {
    try {
      const variables = {
        input: {
          recruitmentProcessId: recruitmentdata?.recruitmentproceesid,
          salaryStructureId: recruitmentdata?.appointmentsalaryStructure?.value,
          ctc: recruitmentdata?.appointmentctc,
          basicPercentage: recruitmentdata?.appointmentbasicPercentage,
          date: recruitmentdata?.appointmentdate,
          empCode: recruitmentdata?.empCode,
        },
      };
      console.log("variables:", variables);

      const variables1 = {
        id: recruitmentdata?.recruitmentproceesid,
        input: {
          appointmentLetter: true,
        },
      };

      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: generateappointment,
            variables: variables,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdatePayslip,
            variables: variables1,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      console.log("response1:", response1.data.data.createAppointmentLetter);
      console.log("response2:", response2.data.data.updateRecruitmentProcess);

      let result1 = response1.data.data.createAppointmentLetter;
      let result2 = response2.data.data.updateRecruitmentProcess;
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      if (result1 && result2.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Appointment Letter Created Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        setOpen(false);
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Appointment Letter Not Created !",
          showConfirmButton: false,
          timer: 2500,
        });

        setOpen(false);
      }
    } catch (error) {
      console.log("error:", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Appointment Letter Not Created !",
        showConfirmButton: false,
        timer: 2500,
      });

      setOpen(false);
    } finally {
      getrecruitmentprocess();
    }
  };

  //update

  const AppointmentUpdate = async () => {
    const variables = {
      input: {
        id: recruitmentdata?.appointmentletterid,
        salaryStructureId: recruitmentdata?.appointmentsalaryStructure?.value,
        ctc: recruitmentdata?.appointmentctc,
        basicPercentage: recruitmentdata?.appointmentbasicPercentage,
        date: recruitmentdata?.appointmentdate,
      },
    };

    console.log("variables:", variables);

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: UpdateAppointment, // Correctly placing the mutation inside query
          variables: variables, // Including variables correctly
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data?.updateAppointmentLetter;

      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Appointment Letter Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setOpen(false);
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Appointment Letter Not Updated !",
          showConfirmButton: false,
          timer: 2500,
        });
        setOpen(false);
      }
    } catch (error) {
      console.log("UpdateAppointmentError:", error.message);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Appointment Letter Not Updated !",
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      getrecruitmentprocess();
    }
  };

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      style={{
        backgroundColor: "rgba(148, 144, 144, 0.5)",
        backdropFilter: "blur( 5px )",
        padding: 0,
        margin: 0,
      }}
      PaperProps={{
        style: {
          backgroundColor: "#fff",
          boxShadow: "none",
        },
      }}
    >
      <DialogTitle
        style={{
          backgroundColor: "#0B1D51",
        }}
      >
        <MaterialBox
          display="flex"
          textAlign="center"
          justifyContent="center"
          alignItem="center"
        >
          <MaterialTypography
            variant="subtitle1"
            fontWeight="bold"
            color="white"
          >
            Change Status
          </MaterialTypography>
        </MaterialBox>
      </DialogTitle>

      <DialogContent>
        {/* Conditional Sections Based on Selected Changevalue */}
        {currentrequest === "Payslip" && (
          <Payslip
            handleFileUpload={handleFileUpload}
            handleupdatepayslip={handleupdatepayslip}
            recruitmentdata={recruitmentdata}
            setrecruitmentdata={setrecruitmentdata}
            handlePay={handlePay}
            setOpen={setOpen}
          />
        )}

        {currentrequest === "Offer" && (
          <Offerletter
            recruitmentdata={recruitmentdata}
            SalaryStructure={SalaryStructure}
            setOpen={setOpen}
            handlerecruitmentchange={handlerecruitmentchange}
            setrecruitmentdata={setrecruitmentdata}
            handleoffer={handleoffer}
            OfferleterUpdate={OfferleterUpdate}
            allowOfferSubmit={allowOfferSubmit}
          />
        )}

        {currentrequest === "Onboarding" && (
          <Onboarding
            recruitmentdata={recruitmentdata}
            allmails={Allemail}
            setOpen={setOpen}
            setInputValue={setInputValue}
            inputValue={inputValue}
            handlerecruitmentchange={handlerecruitmentchange}
            handleOnboarding={handleOnboarding}
          />
        )}

        {currentrequest === "assetrequest" && (
          <AssetRequest
            recruitmentdata={recruitmentdata}
            Allemail={Allemail}
            handlerecruitmentchange={handlerecruitmentchange}
            handleassertmail={handleassertmail}
            setOpen={setOpen}
            setrecruitmentdata={setrecruitmentdata}
          />
        )}

        {currentrequest === "appointmentletter" && (
          <AppointmentLetter
            recruitmentdata={recruitmentdata}
            SalaryStructure={SalaryStructure}
            setOpen={setOpen}
            handlerecruitmentchange={handlerecruitmentchange}
            setrecruitmentdata={setrecruitmentdata}
            handleoffer={CreateAppointment}
            OfferleterUpdate={AppointmentUpdate}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RequestDialog;
